
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import axios from 'axios'
import * as Sentry from '@sentry/vue'

import { consumeError } from '@/domains/global/utils'
import { Job, Invoice } from '@/domains/global/models'
import JobForm from '@/domains/jobs/components/JobForm.vue'
import FinancialCard from '@/domains/jobs/components/financials/index.vue'
import JobMessages from '@/domains/jobs/components/JobMessages/index.vue'
import CostSummary from '@/domains/jobs/components/CostSummary/CostSummary.vue'
import SubmittedJobDetails from './SubmittedJobDetails.vue'

@Component({
  components: { SubmittedJobDetails, JobForm, CostSummary, FinancialCard, JobMessages }
})
export default class JobDetailsTab extends Vue {
  @Prop({ type: Object as () => Job, required: true })
  readonly job!: Job

  invoices: Invoice[] = []

  isEditing = false

  mounted () {
    this.getInvoices()
  }

  async getInvoices() {
    try {
      const response = await axios.get<Invoice[]>(`jobs/${this.job.id}/invoices`)
      this.invoices = response.data
    } catch (error: any) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  refreshData() {
    this.$emit('refresh')
  }

  saveJob(job: Job) {
    this.$emit('update:job', job)
  }

  edit () {
    this.isEditing = true
  }

  cancelEdit () {
    this.isEditing = false
  }
}
